export default {"src":"/_next/static/media/hotel-illustration--full.fd018b71.svg","height":350,"width":874,"blurWidth":0,"blurHeight":0};